import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

const About = () => {
  const calculateTimeLeft = () => {
    const difference = +new Date("2026-06-14T00:00:00+01:00") - +new Date();

    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        days: ("0" + Math.floor(difference / (1000 * 60 * 60 * 24))).slice(-2),
        hours: ("0" + Math.floor((difference / (1000 * 60 * 60)) % 24)).slice(
          -2,
        ),
        minutes: ("0" + Math.floor((difference / 1000 / 60) % 60)).slice(-2),
        seconds: ("0" + Math.floor((difference / 1000) % 60)).slice(-2),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
  });

  const ColorButton = styled(Button)(() => ({
    color: "#049593",
    width: 225,
    height: 65,
    fontWeight: 700,
    fontSize: "16px",
    textTransform: "capitalize",
    backgroundColor: "rgba(0, 0, 0, 0)",
    borderColor: "3px solid #D7A036",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#004165",
      borderColor: "#004165",
    },
  }));

  return (
    <Box
      paddingTop={{ xs: "25%", sm: "5%" }}
      marginBottom={{ xs: "3%", sm: "5%" }}
    >
      <Box
        width={{ xs: "100%", sm: "40%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
      >
        <Typography
          variant="h3"
          color="#D7A036"
          fontWeight={800}
          paddingBottom={"2%"}
          textAlign={"left"}
        >
          <Typography
            component={"span"}
            color="#831312"
            fontWeight={800}
            variant={"h3"}
          >
            About {""}
          </Typography>
          The Award
        </Typography>
      </Box>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignCenter={"center"}
        flexWrap={"wrap"}
        width={"100%"}
      >
        <Box
          width={{ xs: "100%", sm: "50%" }}
          padding={{ xs: "5% 1%", sm: "1% 3% 3% 0%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"body1"}
            fontWeight={500}
            textAlign={"left"}
            color={"#000"}
            data-aos={"fade-up"}
            lineHeight={"1.625em"}
            padding={"2% 10% 1% 0%"}
          >
            The Active Citizen Awards is BudgIT’s initiative and signature move
            to spotlight and appreciate personalities, organizations and
            agencies doing these ground-breaking humanitarian work in Nigeria.
            We believe that the ACA will stir more conversations on the need to
            recognize the tremendous contributions of our civic leaders to
            effective governance and an active civic space in Nigeria.
          </Typography>
          <Box padding={"5% 2% 1% 0%"}>
            <ColorButton
              component={"a"}
              variant="contained"
              size="medium"
              href={"/the-award"}
              endIcon={
                <ArrowRightAltIcon
                  sx={{
                    color: "#049593",
                    height: "32px",
                    width: "32px",
                    "&:hover": {
                      color: "#049593",
                    },
                  }}
                />
              }
            >
              Learn More
            </ColorButton>
          </Box>
        </Box>
        {/* <Box width={{ xs: "100%", sm: "50%" }}>
          <div>
            <iframe
              width="583"
              height="320"
              src={
                "https://www.youtube.com/embed/W7_sZCEasig?enablejsapi=1&html5=1"
              }
              frameBorder="0"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="2023 Active Citizens Awards"
            />
          </div>
        </Box> */}
        <Box
          width={{ xs: "100%", sm: "50%" }}
          padding={{ xs: "5% 0% ", sm: "2%" }}
          data-aos={"fade-up"}
        >
          <Typography
            variant={"h3"}
            fontWeight={800}
            textAlign={"center"}
            color={"#D7A036"}
            paddingBottom={"4%"}
          >
            Nomination Closes
          </Typography>
          {timeLeft.hours || timeLeft.minutes || timeLeft.seconds ? (
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              width={{ xs: "100%", sm: "100%" }}
              marginTop={{ xs: "5%", sm: "1%" }}
            >
              <Box
                display={"flex"}
                flexDirection={"column"}
                backgroundColor={"#831312"}
                width={"35%"}
                margin={{ xs: "1%", sm: "2%" }}
                padding={"2%"}
              >
                <Box padding={"2%"}>
                  <Typography variant="h3" color={"#fff"} textAlign={"center"}>
                    {timeLeft.days}
                  </Typography>
                </Box>
                <Typography
                  variant="body"
                  color={"#fff"}
                  textAlign={"center"}
                  paddingTop={"2%"}
                  fontWeight={700}
                >
                  Days
                </Typography>
              </Box>
              <Box
                display={"flex"}
                flexDirection={"column"}
                backgroundColor={"#831312"}
                width={"35%"}
                margin={{ xs: "1%", sm: "2%" }}
                padding={"2%"}
              >
                <Box padding={"2%"}>
                  <Typography variant="h3" color={"#fff"} textAlign={"center"}>
                    {timeLeft.hours}
                  </Typography>
                </Box>
                <Typography
                  variant="body1"
                  color={"#fff"}
                  textAlign={"center"}
                  paddingTop={"2%"}
                  fontWeight={700}
                >
                  Hours
                </Typography>
              </Box>
              <Box
                display={"flex"}
                flexDirection={"column"}
                backgroundColor={"#831312"}
                width={"35%"}
                margin={{ xs: "1%", sm: "2%" }}
                padding={"2%"}
              >
                <Box padding={"2%"}>
                  <Typography variant="h3" color={"#fff"} textAlign={"center"}>
                    {timeLeft.minutes}
                  </Typography>
                </Box>
                <Typography
                  variant="body1"
                  color={"#fff"}
                  textAlign={"center"}
                  paddingTop={"2%"}
                  fontWeight={700}
                >
                  Minutes
                </Typography>
              </Box>
              <Box
                display={"flex"}
                flexDirection={"column"}
                backgroundColor={"#831312"}
                width={"30%"}
                margin={{ xs: "1%", sm: "2%" }}
                padding={"2%"}
              >
                <Box padding={"2%"}>
                  <Typography variant="h3" color={"#fff"} textAlign={"center"}>
                    {timeLeft.seconds}
                  </Typography>
                </Box>
                <Typography
                  variant="body1"
                  color={"#fff"}
                  textAlign={"center"}
                  paddingTop={"2%"}
                  fontWeight={700}
                >
                  Seconds
                </Typography>
              </Box>
            </Box>
          ) : (
            <Typography
              variant="h3"
              color={"#831312"}
              textAlign={"center"}
              paddingTop={"5%"}
              // fontFamily={("Caveat", "cursive")}
            >
              Nomination Closed
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default About;
